export const EMPTY_CELL_CONTENT = "-";

export const renderWithInherited = <T>(inherited: boolean, render: () => T) =>
  inherited ? EMPTY_CELL_CONTENT : render();
